import React from "react";

import { PageContainer, PageWrapper } from "./styles";
import { Footer } from "components/global/footer";
import { Header } from "components/global/header";
import { ToastProvider } from "components/toast";

interface IPageLayout {
  children: React.ReactNode;
}

export function PageLayout({ children }: IPageLayout) {
  return (
    <ToastProvider>
      <PageContainer>
        <Header />
        <PageWrapper>{children}</PageWrapper>
        <Footer />
      </PageContainer>
    </ToastProvider>
  );
}
